import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

const Delete = ({ confirmDelete, closeDialog, loading }) => {
  return (
    <>
      <DialogTitle>Confirmer la suppression du responsable</DialogTitle>
      <DialogContent>
        Voulez-vous vraiment supprimer l'utilisateur
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={closeDialog}>
          Annuler
        </Button>
        <LoadingButton onClick={confirmDelete} loading={loading}>
          Oui
        </LoadingButton>
      </DialogActions>
    </>
  );
};

export default Delete;
